// extracted by mini-css-extract-plugin
export default {"desktop1":"Desktop_desktop1__R7BvP"};